var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkAnalysisOptionBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.4 19.4",
    style: {
      enableBackground: "new 0 0 19.4 19.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004162",
    d: "M17.9,2.3C17.7,2.1,17.4,2,17,2H9.7H2.4C2,2,1.7,2.1,1.5,2.3C1.2,2.6,1.1,2.9,1.1,3.2v11.2 c0,0.3,0.1,0.6,0.4,0.9c0.3,0.3,0.6,0.4,0.9,0.4h4.1v1.7h3.2h3.2v-1.7H17c0.3,0,0.6-0.1,0.9-0.4c0.3-0.3,0.4-0.6,0.4-0.9V3.2 C18.3,2.9,18.2,2.6,17.9,2.3z M2.4,3.2h7.3H17v0.8l-5.6,5.6L8.1,6.4l-5.7,5.7V3.2z M17,14v0.4H9.7H2.4V14v-0.1l5.7-5.7l3.3,3.3 L17,5.8v6.8V14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkAnalysisOptionBlue);
export default __webpack_public_path__ + "static/media/network_analysis_option_Blue.ed354dd47c07a36e4434bf24d02cb395.svg";
export { ForwardRef as ReactComponent };